(function () {
  "use strict";

  // Optional order correspondence never controls reward, navigation or checkout.
  function installOrderAttribution() {
    if (window.InShapeSurpriseOrderAttribution) return;
    var attribute = "__inshape_surprise_attribution__";
    var pendingToken = "";
    var pending = null;
    var persistedToken = "";
    var nextAttribution = null;
    function validate(value) {
      if (!value || typeof value.token !== "string" || value.token.length > 1500 || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value.token) || typeof value.expiresAt !== "string") return null;
      try {
        var encoded = value.token.split(".")[0].replace(/-/g, "+").replace(/_/g, "/");
        var claims = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "=")));
        var expires = Date.parse(value.expiresAt);
        if (claims.purpose !== "unboxing_order" || typeof claims.id !== "string" || !/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(claims.id)
          || claims.expiresAt !== value.expiresAt || !Number.isFinite(expires) || expires <= Date.now() || expires > Date.now() + 31 * 86400000) return null;
        return { token: value.token, expiresAt: value.expiresAt };
      } catch (_) { return null; }
    }
    function cartUrl() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      var path = typeof root === "string" && root.charAt(0) === "/" && root.charAt(1) !== "/" && root.slice(-1) === "/" ? root + "cart/update.js"
        : (window.theme && window.theme.routes && window.theme.routes.cart_url || "/cart") + "/update.js";
      var url = new URL(path, window.location.origin);
      return url.origin === window.location.origin && /\/cart\/update\.js$/.test(url.pathname) && !url.search && !url.hash ? url.href : "";
    }
    function persist(value) {
      var attribution = validate(value);
      if (!attribution) return Promise.resolve(false);
      if (pending) {
        nextAttribution = pendingToken !== attribution.token ? attribution : null;
        return pending;
      }
      if (attribution.token === persistedToken) return Promise.resolve(false);
      try {
        var url = cartUrl();
        if (!url) return Promise.resolve(false);
        var attributes = {};
        attributes[attribute] = attribution.token;
        var controller = typeof AbortController === "function" ? new AbortController() : null;
        var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 2500);
        pendingToken = attribution.token;
        var attempt = Promise.resolve().then(function () {
          return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ attributes: attributes }), keepalive: true, referrerPolicy: "no-referrer", signal: controller ? controller.signal : undefined });
        }).then(function (response) {
          if (response && response.ok) { persistedToken = attribution.token; return true; }
          return false;
        }).catch(function () { return false; }).finally(function () {
          window.clearTimeout(timer);
          if (pending === attempt) {
            pending = null; pendingToken = "";
            var next = nextAttribution; nextAttribution = null;
            if (next) persist(next);
          }
        });
        pending = attempt;
        return attempt;
      } catch (_) { return Promise.resolve(false); }
    }
    // This is only a client transport; the backend independently verifies the signature and order.
    window.InShapeSurpriseOrderAttribution = { validate: validate, persist: persist };
  }
  installOrderAttribution();

  var STATE_KEY = "inshape-unboxing-reward-v1";
  var TOKEN_KEY = "inshape-unboxing-reward-token-v1";
  var PREVIEW_KEY = "inshape-unboxing-reward-preview-v1";
  var CODE_PATTERN = /^[A-Z0-9_-]{1,100}$/;
  var rejectedReward = "";
  var sentJourneyEvents = new Set();
  var pendingJourneyEvents = new Set();
  var entrySources = ["hang_tag", "direct", "invitation_email", "receipt_email", "recovery_email"];
  var journeyEvents = { unboxing_pdp_viewed: "product_viewed", unboxing_variant_selected: "variant_selected", unboxing_add_to_cart_clicked: "cart_add_clicked", unboxing_discount_confirmed: "cart_discount_applied", unboxing_checkout_started: "checkout_clicked" };

  function load(key) {
    try { return window.sessionStorage.getItem(key) || ""; } catch (_) { return ""; }
  }
  function remove(key) {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  }
  function save(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }
  function missing(status) {
    return { valid: false, status: status || "missing", reason: status || "missing", preview: false };
  }
  function apiBase(value) {
    try {
      var url = new URL(value);
      return url.protocol === "https:" && !url.username && !url.password && !url.search && !url.hash && (url.pathname === "/" || url.pathname === "") ? url.origin : "";
    } catch (_) { return ""; }
  }
  function config() {
    return document.querySelector("[data-ish-unboxing-config]");
  }
  function previewAllowed() {
    var node = config();
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    return Boolean(node && node.dataset.previewAllowed === "true" && (role === "development" || role === "unpublished"));
  }
  function trackingContext(value) {
    if (!value || !/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(value.visitId || "") || ["cards", "wheel", "scratch"].indexOf(value.variant) === -1) return null;
    var requestedSource = new URL(window.location.href).searchParams.get("entry_source");
    return { visitId: value.visitId, variant: value.variant,
      entrySource: entrySources.indexOf(requestedSource) !== -1 ? requestedSource : entrySources.indexOf(value.entrySource) !== -1 ? value.entrySource : value.entrySource === "legacy" ? "direct" : "hang_tag",
      originalEntrySource: entrySources.concat("legacy").indexOf(value.originalEntrySource) !== -1 ? value.originalEntrySource : entrySources.concat("legacy").indexOf(value.entrySource) !== -1 ? value.entrySource : "hang_tag",
      isTest: value.isTest === true, environment: ["development", "qa", "production", "legacy", "unknown"].indexOf(value.environment) !== -1 ? value.environment : "unknown",
      deploymentId: /^[A-Za-z0-9._:-]{1,100}$/.test(value.deploymentId || "") ? value.deploymentId : "" };
  }
  function optionalOrderAttribution(value) {
    try { return window.InShapeSurpriseOrderAttribution.validate(value); } catch (_) { return null; }
  }
  function validate(candidate, preview) {
    if (!candidate || candidate.status !== "active" || candidate.kind !== "shared") return missing("invalid");
    var code = String(candidate.discountCode || candidate.code || "").trim().toUpperCase();
    var minimum = candidate.minimumSubtotal === undefined ? candidate.minimum : candidate.minimumSubtotal;
    if (!CODE_PATTERN.test(code) || candidate.amount !== 20 || minimum !== 0 || candidate.includesFreeShipping !== false || candidate.expiresAt !== null || candidate.currency !== "USD") return missing("invalid");
    if (preview ? candidate.preview !== true || code !== "PREVIEW-SURPRISE20" : candidate.preview === true || code === "PREVIEW-SURPRISE20") return missing("invalid");
    return { valid: true, status: "active", kind: "shared", code: code, amount: 20, currency: "USD",
      minimumSubtotal: 0, includesFreeShipping: false, expiresAt: null, preview: Boolean(preview),
      orderAttribution: preview ? null : optionalOrderAttribution(candidate.orderAttribution),
      source: preview ? "preview" : String(candidate.source || "signed_token"), tracking: preview ? null : trackingContext(candidate.tracking), apiBase: apiBase(candidate.apiBase), storedAt: Date.now() };
  }
  function cached(key, preview) {
    var value;
    try { value = JSON.parse(load(key) || "null"); } catch (_) { value = null; }
    if (!value) return missing();
    var result = validate(value, preview);
    if (!result.valid) remove(key);
    return result;
  }
  function read() {
    return cached(STATE_KEY, false);
  }
  function write(candidate) {
    var state = validate(candidate, false);
    if (state.valid) { save(STATE_KEY, state); rejectedReward = ""; }
    else remove(STATE_KEY);
    return state;
  }
  function clear() {
    remove(STATE_KEY);
  }
  function demo(element) {
    if (!previewAllowed() || !element || !element.isConnected || !element.matches('[data-ish-unboxing-pdp-price][data-preview="true"]')) return null;
    var state = validate({ status: "active", kind: "shared", discountCode: "PREVIEW-SURPRISE20", amount: 20, currency: "USD", minimumSubtotal: 0, includesFreeShipping: false, expiresAt: null, preview: true }, true);
    save(PREVIEW_KEY, state);
    return state;
  }
  function persistOrderAttribution(state) {
    var node = config();
    if (!state || !state.valid || state.preview || node && node.dataset.suppressShared === "true") return;
    try { if (window.sessionStorage.getItem("inshape-active-reward-journey-v1") === "unique") return; } catch (_) {}
    try { window.InShapeSurpriseOrderAttribution.persist(state.orderAttribution); } catch (_) {}
  }
  function resolve(options) {
    var settings = options || {};
    var launch = window.__inshapeUnboxingLaunch || {};
    try { delete window.__inshapeUnboxingLaunch; } catch (_) { window.__inshapeUnboxingLaunch = null; }
    var token = load(TOKEN_KEY);
    var current = read();
    if (launch.hasRewardParam && !token) {
      rejectedReward = "invalid"; clear(); remove(PREVIEW_KEY);
      return Promise.resolve(missing("invalid"));
    }
    if (!token) {
      if (rejectedReward) return Promise.resolve(missing(rejectedReward));
      if (current.valid) { persistOrderAttribution(current); return Promise.resolve(current); }
      var generated = demo(settings.previewElement);
      if (generated) return Promise.resolve(generated);
      if (settings.allowPreview && previewAllowed()) return Promise.resolve(cached(PREVIEW_KEY, true));
      return Promise.resolve(missing());
    }
    if (!/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token) || token.length > 1500) {
      rejectedReward = "invalid"; remove(TOKEN_KEY); clear(); return Promise.resolve(missing("invalid"));
    }
    var node = config() || document.querySelector("[data-ish-unboxing-pdp-price]");
    var base = apiBase(node && node.dataset.apiBase) || current.apiBase;
    if (!base) { rejectedReward = "unavailable"; clear(); return Promise.resolve(missing("unavailable")); }
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 7000);
    var rewardUrl = new URL(base + "/api/unboxing-reward");
    rewardUrl.searchParams.set("token", token);
    var requestedSource = new URL(window.location.href).searchParams.get("entry_source");
    var source = entrySources.indexOf(requestedSource) !== -1 ? requestedSource : current.tracking && current.tracking.entrySource;
    if (entrySources.indexOf(source) !== -1) rewardUrl.searchParams.set("entry_source", source);
    return fetch(rewardUrl.href, {
      credentials: "omit", headers: window.InShapeUnboxingQA ? window.InShapeUnboxingQA.headers(rewardUrl.href, { Accept: "application/json" }) : { Accept: "application/json" }, referrerPolicy: "no-referrer",
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok || !payload.ok || !payload.reward) {
          rejectedReward = response.status === 401 ? "invalid" : "unavailable";
          clear(); if (response.status === 401) remove(TOKEN_KEY);
          return missing(rejectedReward);
        }
        var state = write(Object.assign({}, payload.reward, { source: "signed_token", apiBase: base, tracking: payload.tracking,
          orderAttribution: payload.tracking && payload.tracking.environment === "production" && payload.tracking.isTest !== true ? payload.orderAttribution : null }));
        persistOrderAttribution(state);
        if (!state.valid) rejectedReward = "invalid";
        return state;
      });
    }).catch(function () { rejectedReward = "unavailable"; clear(); return missing("unavailable"); }).finally(function () { window.clearTimeout(timer); });
  }
  function cartDiscountCents(cart, state) {
    if (!state || !state.valid || state.preview || state.kind !== "shared" || !CODE_PATTERN.test(state.code || "")) return 0;
    var amount = 0;
    function add(entry, line) {
      var application = line ? entry.discount_application : entry;
      var cents = Number(line ? entry.amount : entry.total_allocated_amount);
      if (application && String(application.title || "").trim().toUpperCase() === state.code && Number.isSafeInteger(cents) && cents > 0) amount += cents;
    }
    (cart && cart.cart_level_discount_applications || []).forEach(function (entry) { add(entry, false); });
    (cart && cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (entry) { add(entry, true); });
    });
    return amount;
  }
  function checkCart(cart, state) {
    return cartDiscountCents(cart, state) > 0;
  }
  function checkoutControl(event) {
    var path = typeof event.composedPath === "function" ? event.composedPath() : [event.target];
    return path.some(function (node) {
      return Boolean(node && typeof node.closest === "function" && node.closest('[name="checkout"], a[href*="/checkout"], .checkout-button, [data-action="checkout"], [data-ish-unboxing-checkout]'));
    });
  }
  function track(eventName, details, state) {
    var journeyEvent = journeyEvents[eventName];
    if (!journeyEvent || !state || !state.valid) return Promise.resolve();
    var context = state.preview ? null : trackingContext(state.tracking);
    var payload = { event: eventName, unboxing_reward: true, reward_kind: "shared", preview: Boolean(state.preview) };
    ["page_type", "product_handle", "variant_selection", "option_name", "option_value", "confirmation_source", "reward_source"].forEach(function (key) {
      var value = details && details[key];
      if (typeof value === "string" && value.length <= 100) payload[key] = value;
    });
    if (context) Object.assign(payload, { journey_id: context.visitId, experiment_variant: context.variant, entry_source: context.entrySource,
      original_entry_source: context.originalEntrySource, is_test: context.isTest, environment: context.environment, deployment_id: context.deploymentId });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (state.preview || !context || !state.apiBase) return Promise.resolve();
    var key = context.visitId + ":" + journeyEvent + ":" + context.entrySource;
    if (sentJourneyEvents.has(key) || pendingJourneyEvents.has(key)) return Promise.resolve();
    pendingJourneyEvents.add(key);
    var sent = window.InShapeUnboxingQA ? window.InShapeUnboxingQA.postJourney(state.apiBase + "/api/journey", { visit: context.visitId, variant: context.variant, event: journeyEvent, entrySource: context.entrySource }) : Promise.resolve(false);
    return sent.then(function (successful) { if (successful) sentJourneyEvents.add(key); })
      .catch(function () {}).finally(function () { pendingJourneyEvents.delete(key); });
  }
  function applyState(state) {
    var real = Boolean(state && state.valid && !state.preview);
    var preview = Boolean(state && state.valid && state.preview);
    document.documentElement.classList.toggle("ish-unboxing-has-reward", real);
    document.documentElement.classList.toggle("ish-unboxing-no-reward", !real && !preview);
    document.documentElement.classList.toggle("ish-unboxing-preview", preview);
    if (document.body) {
      document.body.classList.toggle("ish-unboxing-reward-active", real);
      document.body.classList.toggle("ish-unboxing-reward-preview", preview);
    }
    window.dispatchEvent(new CustomEvent("inshape:unboxing-reward-state", { detail: state }));
  }
  window.InShapeUnboxingReward = { resolve: resolve, read: read, write: write, clear: clear,
    track: track, checkoutControl: checkoutControl, applyState: applyState, checkCart: checkCart, cartDiscountCents: cartDiscountCents };
})();
